import { Injectable } from '@angular/core';
import { IDocumentGroup, IOrderEntryDocument } from './order-entry-documents-data.service';
import { Observable, Subject } from 'rxjs';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';
import { urlUtil } from '../../../../shared/util';
import { ICellRendererParams } from 'ag-grid-community';
import { AuthService } from '../../../../shared/services/auth/auth.service';
import { OrderEntryWebshopService } from '../webshop/order-entry-webshop.service';

@Injectable()
export class OrderEntryDocumentsService {
  public onDocumentChange:Observable<IDocumentGroup[]>;

  private documentChangeSubject:Subject<IDocumentGroup[]> = new Subject<IDocumentGroup[]>();
  private _addedDocuments:IDocumentGroup[] = [];
  private _deletedDocuments:number[] = [];
  private _documents:IDocumentGroup[] = [];

  constructor(
    private authService:AuthService,
    private orderEntryWebshopService:OrderEntryWebshopService
  ) {
    this.onDocumentChange = this.documentChangeSubject.asObservable();
  }

  public get documents():IDocumentGroup[] {
    return this._documents;
  }

  public set documents(documents:IDocumentGroup[]) {
    this._documents = this.transformDocs(documents);
    this.documentChangeSubject.next(this.documents);
  }

  public get addedDocuments():IDocumentGroup[] {
    return this._addedDocuments;
  }

  public get deletedDocuments():number[] {
    return this._deletedDocuments;
  }

  public addAddedDocument(documentId:string | number, caveatDefinitionId:number) {
    const addedDoc:any = { id: documentId };

    if (caveatDefinitionId) {
      addedDoc.caveatDefinitionId = caveatDefinitionId;
    }

    this._addedDocuments.push(addedDoc);
  }

  public addDeletedDocument(documentId:string | number):void {
    if (_.findWhere(this.addedDocuments, { id: documentId })) {
      this._addedDocuments = _.reject(this.addedDocuments, (addedDoc:any) => addedDoc.id === documentId);
    } else {
      this._deletedDocuments.push(<number>documentId);
    }
  }

  public getDocumentUrl = (doc:IOrderEntryDocument, params:ICellRendererParams, orderId?:number):string => {
    if (doc.url) {
      return doc.url;
    }

    if (doc.id) {
      const url: string = `rest/orderentry/webshops/${this.orderEntryWebshopService.selectedShop?.id}/countries/${this.orderEntryWebshopService.selectedCountry?.id}/documents/${doc.id}`;
      const urlParams: IObject = {
        orderId: orderId || params?.context?.orderId,
        companyCountryId: this.orderEntryWebshopService.shopContext?.bp?.location?.companyCountry?.id
      };

      return this.authService.authenticatedUrl(urlUtil.setQueryParams(url, urlParams));
    }
  };

  private transformDocs(documents:IDocumentGroup[]):IDocumentGroup[] {
    return _.map(documents, (doc:IDocumentGroup) => {
      if (doc.needsDocument) {
        doc.error = {
          type: 'error',
          message: 'ORDERENTRY.DOCS.NECESSARY_DOCS'
        };
      } else {
        doc.error = undefined;
      }

      doc.documents = _.map(doc.documents, (docType:IOrderEntryDocument) => {
        if (docType.catalogOutdated) {
          docType.warning = {
            type: 'warning',
            message: 'ORDERENTRY.DOCS.OUTDATED_CATALOG'
          };
        } else {
          docType.warning = undefined;
        }

        return docType;
      });

      return doc;
    });
  }

  public clear():void {
    this.documents = [];
    this._deletedDocuments = [];
    this._addedDocuments = [];
  }
}